/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  InfringingImageProtocolsCreateCollectionRequest,
  InfringingImageProtocolsCreateCollectionResponse,
  InfringingImageProtocolsCreateInfringingImageLibraryByPresignedRequest,
  InfringingImageProtocolsDeleteCollectionRequest,
  InfringingImageProtocolsGetAllCollectionsRequest,
  InfringingImageProtocolsGetAllCollectionsResponse,
  InfringingImageProtocolsGetAllInfringingImagesRequest,
  InfringingImageProtocolsGetAllInfringingImagesResponse,
  InfringingImageProtocolsGetCollectionDetailRequest,
  InfringingImageProtocolsGetCollectionDetailResponse,
  InfringingImageProtocolsGetImageCountByBrandResponse,
  InfringingImageProtocolsGetInfringingImagePresignedUrlRequest,
  InfringingImageProtocolsGetInfringingImagePresignedUrlResponse,
  InfringingImageProtocolsUpdateCollectionRequest,
  InfringingImageProtocolsUpdateInfringingImageLibraryByPresignedRequest,
  MarqCommonProtocolEmptyResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class InfringingImage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags InfringingImage
   * @name GetImageCountByBrandList
   * @request GET:/infringing-image/get-image-count-by-brand
   */
  getImageCountByBrandList = (params: RequestParams = {}) =>
    this.http.request<InfringingImageProtocolsGetImageCountByBrandResponse, any>({
      path: `/infringing-image/get-image-count-by-brand`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name GetAllCollectionsCreate
   * @request POST:/infringing-image/get-all-collections
   */
  getAllCollectionsCreate = (data: InfringingImageProtocolsGetAllCollectionsRequest, params: RequestParams = {}) =>
    this.http.request<InfringingImageProtocolsGetAllCollectionsResponse, any>({
      path: `/infringing-image/get-all-collections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name CreateCollectionCreate
   * @request POST:/infringing-image/create-collection
   */
  createCollectionCreate = (data: InfringingImageProtocolsCreateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<InfringingImageProtocolsCreateCollectionResponse, any>({
      path: `/infringing-image/create-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name UpdateCollectionCreate
   * @request POST:/infringing-image/update-collection
   */
  updateCollectionCreate = (data: InfringingImageProtocolsUpdateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/infringing-image/update-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name DeleteCollectionCreate
   * @request POST:/infringing-image/delete-collection
   */
  deleteCollectionCreate = (data: InfringingImageProtocolsDeleteCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/infringing-image/delete-collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name PresignedCreate
   * @request POST:/infringing-image/presigned
   */
  presignedCreate = (data: InfringingImageProtocolsGetInfringingImagePresignedUrlRequest, params: RequestParams = {}) =>
    this.http.request<InfringingImageProtocolsGetInfringingImagePresignedUrlResponse, any>({
      path: `/infringing-image/presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name AllInfringingImagesCreate
   * @request POST:/infringing-image/all-infringing-images
   */
  allInfringingImagesCreate = (
    data: InfringingImageProtocolsGetAllInfringingImagesRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<InfringingImageProtocolsGetAllInfringingImagesResponse, any>({
      path: `/infringing-image/all-infringing-images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name GetCollectionDetailCreate
   * @request POST:/infringing-image/get-collection-detail
   */
  getCollectionDetailCreate = (data: InfringingImageProtocolsGetCollectionDetailRequest, params: RequestParams = {}) =>
    this.http.request<InfringingImageProtocolsGetCollectionDetailResponse, any>({
      path: `/infringing-image/get-collection-detail`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name CreateInfringingImageLibraryPresignedCreate
   * @request POST:/infringing-image/create-infringing-image-library-presigned
   */
  createInfringingImageLibraryPresignedCreate = (
    data: InfringingImageProtocolsCreateInfringingImageLibraryByPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/infringing-image/create-infringing-image-library-presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags InfringingImage
   * @name UpdateInfringingImageLibraryPresignedCreate
   * @request POST:/infringing-image/update-infringing-image-library-presigned
   */
  updateInfringingImageLibraryPresignedCreate = (
    data: InfringingImageProtocolsUpdateInfringingImageLibraryByPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/infringing-image/update-infringing-image-library-presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
